import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Copy, ExternalLink, X, User, Ticket } from "lucide-react";

const ShortIdModal = ({
  isOpen,
  onClose,
  userData = { shortId: "USR123", username: "john_doe", ticketCount: 5 },
}) => {
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const handleCopyId = async () => {
    try {
      await navigator.clipboard.writeText(userData.shortId);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const handleRedirect = () => {
    navigate(`/we/get-qr-tickets?tid=${userData.shortId}`);
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4"
      style={{ zIndex: 9999 }}
    >
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md transform transition-all duration-300 scale-100">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-6 rounded-t-2xl relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-full transition-colors"
          >
            <X size={20} />
          </button>
          <div className="text-white">
            <h2 className="text-2xl font-bold mb-2">Ticket</h2>
            <p className="text-blue-100">Ticket Information</p>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Short ID Section */}
          <div className="bg-gray-50 rounded-xl p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="bg-blue-100 p-2 rounded-lg">
                  <User className="text-blue-600" size={20} />
                </div>
                <div>
                  <p className="text-sm text-gray-600">Ticket ID</p>
                  <p className="font-mono font-semibold text-lg">
                    {userData.shortId}
                  </p>
                </div>
              </div>
              <button
                onClick={handleCopyId}
                className="flex items-center space-x-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors"
              >
                <Copy size={16} />
                <span>{copied ? "Copied!" : "Copy"}</span>
              </button>
            </div>
          </div>

          {/* Username Section */}
          <div className="flex items-center space-x-4">
            <div className="bg-green-100 p-3 rounded-lg">
              <User className="text-green-600" size={24} />
            </div>
            <div>
              <p className="text-sm text-gray-600">Name</p>
              <p className="font-semibold text-xl">{userData.username}</p>
            </div>
          </div>

          {/* Ticket Count Section */}
          <div className="flex items-center space-x-4">
            <div className="bg-orange-100 p-3 rounded-lg">
              <Ticket className="text-orange-600" size={24} />
            </div>
            <div>
              <p className="text-sm text-gray-600">Ticket Count</p>
              <p className="font-semibold text-xl">{userData.ticketCount}</p>
            </div>
          </div>

          <button
            onClick={handleRedirect}
            className="w-full bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-semibold py-3 px-6 rounded-xl flex items-center justify-center space-x-2 transition-all duration-200 transform hover:scale-105"
          >
            <ExternalLink size={20} />
            <span>Genrate Qr</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShortIdModal;
